import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { HeaderComponent } from '../header/header.component';

export interface ChartPreset {
  id: string;
  label: string;
  description: string;
  icon: string;
  focusProperty: 'dataLayer' | 'indicator' | 'feature';
  groupProperty: 'dataLayer' | 'indicator' | 'feature';
}

@Component({
  selector: 'app-chart-config-presets',
  standalone: true,
  imports: [NgForOf, NgIf, ButtonDirective, HeaderComponent],
  templateUrl: './chart-config-presets.component.html',
  styleUrl: './chart-config-presets.component.scss',
})
export class ChartConfigPresetsComponent {
  @Input() isPoiType = false;
  @Input() currentFocusProperty?: string;
  @Output() presetSelected = new EventEmitter<ChartPreset>();

  readonly presets: ChartPreset[] = [
    {
      id: 'regional-comparison',
      label: 'Regionaler Vergleich',
      description: 'Vergleich zwischen Teilräumen/Standorten',
      icon: 'fas fa-signs-post',
      focusProperty: 'dataLayer',
      groupProperty: 'feature',
    },
    {
      id: 'time-comparison',
      label: 'Zeitlicher Vergleich',
      description: 'Entwicklung über mehrere Jahre',
      icon: 'fas fa-chart-line',
      focusProperty: 'indicator',
      groupProperty: 'dataLayer',
    },
    {
      id: 'indicator-comparison',
      label: 'Indikator-Vergleich',
      description: 'Mehrere Indikatoren vergleichen',
      icon: 'fas fa-ruler-combined',
      focusProperty: 'feature',
      groupProperty: 'indicator',
    },
  ];

  selectPreset(preset: ChartPreset): void {
    this.presetSelected.emit(preset);
  }

  isActive(preset: ChartPreset): boolean {
    return preset.focusProperty === this.currentFocusProperty;
  }
}
